module.exports = __webpack_public_path__ + "static/img/img3.96afa49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feature/img3.png
// module id = /zZA
// module chunks = 1